import { useState, useContext } from "react";
import { OAuthProvider, signInWithEmailAndPassword, signInWithPopup, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase/config";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const navigate = useNavigate();
  const { loginAsGuest } = useContext(AuthContext);

  const handleMicrosoftLogin = async () => {
    setError("");
    try {
      const provider = new OAuthProvider("microsoft.com");
      await signInWithPopup(auth, provider);
      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      setError("Microsoft sign-in failed. Please try again.");
    }
  };

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      const userRef = doc(db, "users", result.user.uid);
      const snap = await getDoc(userRef);
      const role = snap.exists() ? snap.data()?.role : null;

      if (role !== "admin") {
        await signOut(auth);
        setError("Email login is restricted to admins.");
        return;
      }

      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      setError("Invalid email or password");
    }
  };

  const handleGuestLogin = () => {
    loginAsGuest();
    navigate("/dashboard");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: "#f5f7fb",
      }}
    >
      <div
        style={{
          width: "100%",
          background: "#4a90e2",
          color: "white",
          padding: "1.25rem 1.5rem",
          textAlign: "center",
          fontSize: "1.5rem",
          fontWeight: "700",
          letterSpacing: "0.3px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
        }}
      >
        Classroom Companion
      </div>

      <div
        style={{
          width: "100%",
          maxWidth: "420px",
          marginTop: "4rem",
          background: "white",
          borderRadius: "12px",
          padding: "2rem",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        }}
      >
        <h1 style={{ marginTop: 0, marginBottom: "1.5rem", textAlign: "center" }}>Login</h1>

        <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
          <button type="button" onClick={handleMicrosoftLogin} style={styles.primaryButton}>
            Sign in with Microsoft
          </button>

          <button type="button" onClick={handleGuestLogin} style={styles.demoButton}>
            Demo Account (Recruiter)
          </button>

          <button type="button" onClick={() => setShowAdminLogin((prev) => !prev)} style={styles.secondaryButton}>
            {showAdminLogin ? "Hide admin login" : "Admin login"}
          </button>
        </div>

        {showAdminLogin && (
          <form onSubmit={handleAdminLogin} style={{ marginTop: "1rem", display: "grid", gap: "0.75rem" }}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
            />

            <button type="submit" style={styles.primaryButton}>Admin login</button>
          </form>
        )}

        {error && <p style={{ color: "#b00020", marginTop: "1rem" }}>{error}</p>}
      </div>
    </div>
  );
}

const styles = {
  primaryButton: {
    background: "#4a90e2",
    color: "white",
    border: "none",
    padding: "0.75rem 1rem",
    borderRadius: "8px",
    fontWeight: "600",
    cursor: "pointer",
  },
  secondaryButton: {
    background: "white",
    color: "#4a90e2",
    border: "1px solid #4a90e2",
    padding: "0.75rem 1rem",
    borderRadius: "8px",
    fontWeight: "600",
    cursor: "pointer",
  },
  demoButton: {
    background: "#50c878",
    color: "white",
    border: "none",
    padding: "0.75rem 1rem",
    borderRadius: "8px",
    fontWeight: "600",
    cursor: "pointer",
  },
  input: {
    padding: "0.65rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid #cfd7e3",
    fontSize: "1rem",
  },
};